import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";

const TypingEffect = () => {
  const [texts] = useTypewriter({
    words: ["Émotions", "Dépassement", "Amitiés", "Défis", "Créativité"],
    loop: {},
    typeSpeed: 300,
    delaySpeed: 80,
  });
  return (
    <div className="text-white">
      <h2 className="md:text-6xl text-4xl font-bold">
        Fédération Québécoise de Soccer sur Table
      </h2>
      <h4 className="md:text-4xl text-3xl my-5 font-semibold bg-red-500 md:w-4/6 w-11/12 rounded mx-auto py-2.5 px-1">
        Bienvenue à tous!
      </h4>
      <div className="md:text-3xl text-2xl font-semibold">
        <span>{texts}</span>
        <Cursor cursorStyle="." cursorColor="white" />
      </div>
      <p className="my-3">
      Notre mission est de rassembler petits et grands autour du babyfoot, 
      en faisant découvrir ce sport passionnant et en offrant les ressources 
      nécessaires pour favoriser la progression de tous.
      </p>
      <a
        className="btn bg-transparent border-2 border-amber-500 text-white px-5 transition-all hover:scale-95 hover:bg-amber-500 hover:border-amber-500"
        href="#aboutus"
      >
        En savoir plus
      </a>
    </div>
  );
};

export default TypingEffect;
